import { jsx as ht, jsxs as Eo } from "react/jsx-runtime";
import Re, { createContext as Oo, useState as z, useRef as le, useEffect as C, useContext as Ro, useLayoutEffect as Co, useCallback as To, useImperativeHandle as Lo } from "react";
import { I as ko } from "./ic_close-BJ5TqFBV.mjs";
import { c as Kt } from "./tw-cn-mXgPecoF.mjs";
import { I as No } from "./icon-button-UFwDzoPr.mjs";
function Do(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
const He = Math.min, Ce = Math.max, yt = Math.round, vt = Math.floor, de = (e) => ({
  x: e,
  y: e
}), Po = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, zo = {
  start: "end",
  end: "start"
};
function kt(e, t, n) {
  return Ce(e, He(t, n));
}
function lt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Te(e) {
  return e.split("-")[0];
}
function it(e) {
  return e.split("-")[1];
}
function co(e) {
  return e === "x" ? "y" : "x";
}
function $t(e) {
  return e === "y" ? "height" : "width";
}
const $o = /* @__PURE__ */ new Set(["top", "bottom"]);
function be(e) {
  return $o.has(Te(e)) ? "y" : "x";
}
function Bt(e) {
  return co(be(e));
}
function Bo(e, t, n) {
  n === void 0 && (n = !1);
  const o = it(e), l = Bt(e), r = $t(l);
  let i = l === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[r] > t.floating[r] && (i = wt(i)), [i, wt(i)];
}
function Io(e) {
  const t = wt(e);
  return [Nt(e), t, Nt(t)];
}
function Nt(e) {
  return e.replace(/start|end/g, (t) => zo[t]);
}
const Xt = ["left", "right"], Yt = ["right", "left"], Mo = ["top", "bottom"], jo = ["bottom", "top"];
function Fo(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Yt : Xt : t ? Xt : Yt;
    case "left":
    case "right":
      return t ? Mo : jo;
    default:
      return [];
  }
}
function Wo(e, t, n, o) {
  const l = it(e);
  let r = Fo(Te(e), n === "start", o);
  return l && (r = r.map((i) => i + "-" + l), t && (r = r.concat(r.map(Nt)))), r;
}
function wt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Po[t]);
}
function Vo(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function ao(e) {
  return typeof e != "number" ? Vo(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function gt(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: l
  } = e;
  return {
    width: o,
    height: l,
    top: n,
    left: t,
    right: t + o,
    bottom: n + l,
    x: t,
    y: n
  };
}
function Ut(e, t, n) {
  let {
    reference: o,
    floating: l
  } = e;
  const r = be(t), i = Bt(t), s = $t(i), c = Te(t), a = r === "y", p = o.x + o.width / 2 - l.width / 2, d = o.y + o.height / 2 - l.height / 2, h = o[s] / 2 - l[s] / 2;
  let f;
  switch (c) {
    case "top":
      f = {
        x: p,
        y: o.y - l.height
      };
      break;
    case "bottom":
      f = {
        x: p,
        y: o.y + o.height
      };
      break;
    case "right":
      f = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      f = {
        x: o.x - l.width,
        y: d
      };
      break;
    default:
      f = {
        x: o.x,
        y: o.y
      };
  }
  switch (it(t)) {
    case "start":
      f[i] -= h * (n && a ? -1 : 1);
      break;
    case "end":
      f[i] += h * (n && a ? -1 : 1);
      break;
  }
  return f;
}
const Ho = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: l = "absolute",
    middleware: r = [],
    platform: i
  } = n, s = r.filter(Boolean), c = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let a = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: l
  }), {
    x: p,
    y: d
  } = Ut(a, o, c), h = o, f = {}, m = 0;
  for (let w = 0; w < s.length; w++) {
    const {
      name: x,
      fn: g
    } = s[w], {
      x: _,
      y: S,
      data: T,
      reset: O
    } = await g({
      x: p,
      y: d,
      initialPlacement: o,
      placement: h,
      strategy: l,
      middlewareData: f,
      rects: a,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    p = _ ?? p, d = S ?? d, f = {
      ...f,
      [x]: {
        ...f[x],
        ...T
      }
    }, O && m <= 50 && (m++, typeof O == "object" && (O.placement && (h = O.placement), O.rects && (a = O.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: l
    }) : O.rects), {
      x: p,
      y: d
    } = Ut(a, h, c)), w = -1);
  }
  return {
    x: p,
    y: d,
    placement: h,
    strategy: l,
    middlewareData: f
  };
};
async function uo(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: l,
    platform: r,
    rects: i,
    elements: s,
    strategy: c
  } = e, {
    boundary: a = "clippingAncestors",
    rootBoundary: p = "viewport",
    elementContext: d = "floating",
    altBoundary: h = !1,
    padding: f = 0
  } = lt(t, e), m = ao(f), x = s[h ? d === "floating" ? "reference" : "floating" : d], g = gt(await r.getClippingRect({
    element: (n = await (r.isElement == null ? void 0 : r.isElement(x))) == null || n ? x : x.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(s.floating)),
    boundary: a,
    rootBoundary: p,
    strategy: c
  })), _ = d === "floating" ? {
    x: o,
    y: l,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, S = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(s.floating)), T = await (r.isElement == null ? void 0 : r.isElement(S)) ? await (r.getScale == null ? void 0 : r.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, O = gt(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: _,
    offsetParent: S,
    strategy: c
  }) : _);
  return {
    top: (g.top - O.top + m.top) / T.y,
    bottom: (O.bottom - g.bottom + m.bottom) / T.y,
    left: (g.left - O.left + m.left) / T.x,
    right: (O.right - g.right + m.right) / T.x
  };
}
const qo = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: l,
      rects: r,
      platform: i,
      elements: s,
      middlewareData: c
    } = t, {
      element: a,
      padding: p = 0
    } = lt(e, t) || {};
    if (a == null)
      return {};
    const d = ao(p), h = {
      x: n,
      y: o
    }, f = Bt(l), m = $t(f), w = await i.getDimensions(a), x = f === "y", g = x ? "top" : "left", _ = x ? "bottom" : "right", S = x ? "clientHeight" : "clientWidth", T = r.reference[m] + r.reference[f] - h[f] - r.floating[m], O = h[f] - r.reference[f], j = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a));
    let L = j ? j[S] : 0;
    (!L || !await (i.isElement == null ? void 0 : i.isElement(j))) && (L = s.floating[S] || r.floating[m]);
    const Z = T / 2 - O / 2, X = L / 2 - w[m] / 2 - 1, Y = He(d[g], X), ce = He(d[_], X), G = Y, ae = L - w[m] - ce, R = L / 2 - w[m] / 2 + Z, K = kt(G, R, ae), W = !c.arrow && it(l) != null && R !== K && r.reference[m] / 2 - (R < G ? Y : ce) - w[m] / 2 < 0, $ = W ? R < G ? R - G : R - ae : 0;
    return {
      [f]: h[f] + $,
      data: {
        [f]: K,
        centerOffset: R - K - $,
        ...W && {
          alignmentOffset: $
        }
      },
      reset: W
    };
  }
}), Ko = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: l,
        middlewareData: r,
        rects: i,
        initialPlacement: s,
        platform: c,
        elements: a
      } = t, {
        mainAxis: p = !0,
        crossAxis: d = !0,
        fallbackPlacements: h,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: w = !0,
        ...x
      } = lt(e, t);
      if ((n = r.arrow) != null && n.alignmentOffset)
        return {};
      const g = Te(l), _ = be(s), S = Te(s) === s, T = await (c.isRTL == null ? void 0 : c.isRTL(a.floating)), O = h || (S || !w ? [wt(s)] : Io(s)), j = m !== "none";
      !h && j && O.push(...Wo(s, w, m, T));
      const L = [s, ...O], Z = await uo(t, x), X = [];
      let Y = ((o = r.flip) == null ? void 0 : o.overflows) || [];
      if (p && X.push(Z[g]), d) {
        const R = Bo(l, i, T);
        X.push(Z[R[0]], Z[R[1]]);
      }
      if (Y = [...Y, {
        placement: l,
        overflows: X
      }], !X.every((R) => R <= 0)) {
        var ce, G;
        const R = (((ce = r.flip) == null ? void 0 : ce.index) || 0) + 1, K = L[R];
        if (K && (!(d === "alignment" ? _ !== be(K) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        Y.every((N) => be(N.placement) === _ ? N.overflows[0] > 0 : !0)))
          return {
            data: {
              index: R,
              overflows: Y
            },
            reset: {
              placement: K
            }
          };
        let W = (G = Y.filter(($) => $.overflows[0] <= 0).sort(($, N) => $.overflows[1] - N.overflows[1])[0]) == null ? void 0 : G.placement;
        if (!W)
          switch (f) {
            case "bestFit": {
              var ae;
              const $ = (ae = Y.filter((N) => {
                if (j) {
                  const V = be(N.placement);
                  return V === _ || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  V === "y";
                }
                return !0;
              }).map((N) => [N.placement, N.overflows.filter((V) => V > 0).reduce((V, he) => V + he, 0)]).sort((N, V) => N[1] - V[1])[0]) == null ? void 0 : ae[0];
              $ && (W = $);
              break;
            }
            case "initialPlacement":
              W = s;
              break;
          }
        if (l !== W)
          return {
            reset: {
              placement: W
            }
          };
      }
      return {};
    }
  };
}, Xo = /* @__PURE__ */ new Set(["left", "top"]);
async function Yo(e, t) {
  const {
    placement: n,
    platform: o,
    elements: l
  } = e, r = await (o.isRTL == null ? void 0 : o.isRTL(l.floating)), i = Te(n), s = it(n), c = be(n) === "y", a = Xo.has(i) ? -1 : 1, p = r && c ? -1 : 1, d = lt(t, e);
  let {
    mainAxis: h,
    crossAxis: f,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof m == "number" && (f = s === "end" ? m * -1 : m), c ? {
    x: f * p,
    y: h * a
  } : {
    x: h * a,
    y: f * p
  };
}
const Uo = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: l,
        y: r,
        placement: i,
        middlewareData: s
      } = t, c = await Yo(t, e);
      return i === ((n = s.offset) == null ? void 0 : n.placement) && (o = s.arrow) != null && o.alignmentOffset ? {} : {
        x: l + c.x,
        y: r + c.y,
        data: {
          ...c,
          placement: i
        }
      };
    }
  };
}, Jo = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: l
      } = t, {
        mainAxis: r = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (x) => {
            let {
              x: g,
              y: _
            } = x;
            return {
              x: g,
              y: _
            };
          }
        },
        ...c
      } = lt(e, t), a = {
        x: n,
        y: o
      }, p = await uo(t, c), d = be(Te(l)), h = co(d);
      let f = a[h], m = a[d];
      if (r) {
        const x = h === "y" ? "top" : "left", g = h === "y" ? "bottom" : "right", _ = f + p[x], S = f - p[g];
        f = kt(_, f, S);
      }
      if (i) {
        const x = d === "y" ? "top" : "left", g = d === "y" ? "bottom" : "right", _ = m + p[x], S = m - p[g];
        m = kt(_, m, S);
      }
      const w = s.fn({
        ...t,
        [h]: f,
        [d]: m
      });
      return {
        ...w,
        data: {
          x: w.x - n,
          y: w.y - o,
          enabled: {
            [h]: r,
            [d]: i
          }
        }
      };
    }
  };
};
function bt() {
  return typeof window < "u";
}
function Ke(e) {
  return fo(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Q(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function me(e) {
  var t;
  return (t = (fo(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function fo(e) {
  return bt() ? e instanceof Node || e instanceof Q(e).Node : !1;
}
function ie(e) {
  return bt() ? e instanceof Element || e instanceof Q(e).Element : !1;
}
function pe(e) {
  return bt() ? e instanceof HTMLElement || e instanceof Q(e).HTMLElement : !1;
}
function Jt(e) {
  return !bt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Q(e).ShadowRoot;
}
const Qo = /* @__PURE__ */ new Set(["inline", "contents"]);
function st(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: l
  } = se(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !Qo.has(l);
}
const Zo = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Go(e) {
  return Zo.has(Ke(e));
}
const en = [":popover-open", ":modal"];
function xt(e) {
  return en.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const tn = ["transform", "translate", "scale", "rotate", "perspective"], on = ["transform", "translate", "scale", "rotate", "perspective", "filter"], nn = ["paint", "layout", "strict", "content"];
function It(e) {
  const t = Mt(), n = ie(e) ? se(e) : e;
  return tn.some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || on.some((o) => (n.willChange || "").includes(o)) || nn.some((o) => (n.contain || "").includes(o));
}
function rn(e) {
  let t = xe(e);
  for (; pe(t) && !qe(t); ) {
    if (It(t))
      return t;
    if (xt(t))
      return null;
    t = xe(t);
  }
  return null;
}
function Mt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const ln = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function qe(e) {
  return ln.has(Ke(e));
}
function se(e) {
  return Q(e).getComputedStyle(e);
}
function _t(e) {
  return ie(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function xe(e) {
  if (Ke(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Jt(e) && e.host || // Fallback.
    me(e)
  );
  return Jt(t) ? t.host : t;
}
function po(e) {
  const t = xe(e);
  return qe(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : pe(t) && st(t) ? t : po(t);
}
function rt(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const l = po(e), r = l === ((o = e.ownerDocument) == null ? void 0 : o.body), i = Q(l);
  if (r) {
    const s = Dt(i);
    return t.concat(i, i.visualViewport || [], st(l) ? l : [], s && n ? rt(s) : []);
  }
  return t.concat(l, rt(l, [], n));
}
function Dt(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function mo(e) {
  const t = se(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const l = pe(e), r = l ? e.offsetWidth : n, i = l ? e.offsetHeight : o, s = yt(n) !== r || yt(o) !== i;
  return s && (n = r, o = i), {
    width: n,
    height: o,
    $: s
  };
}
function jt(e) {
  return ie(e) ? e : e.contextElement;
}
function Ve(e) {
  const t = jt(e);
  if (!pe(t))
    return de(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: l,
    $: r
  } = mo(t);
  let i = (r ? yt(n.width) : n.width) / o, s = (r ? yt(n.height) : n.height) / l;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const sn = /* @__PURE__ */ de(0);
function ho(e) {
  const t = Q(e);
  return !Mt() || !t.visualViewport ? sn : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function cn(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Q(e) ? !1 : t;
}
function Le(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const l = e.getBoundingClientRect(), r = jt(e);
  let i = de(1);
  t && (o ? ie(o) && (i = Ve(o)) : i = Ve(e));
  const s = cn(r, n, o) ? ho(r) : de(0);
  let c = (l.left + s.x) / i.x, a = (l.top + s.y) / i.y, p = l.width / i.x, d = l.height / i.y;
  if (r) {
    const h = Q(r), f = o && ie(o) ? Q(o) : o;
    let m = h, w = Dt(m);
    for (; w && o && f !== m; ) {
      const x = Ve(w), g = w.getBoundingClientRect(), _ = se(w), S = g.left + (w.clientLeft + parseFloat(_.paddingLeft)) * x.x, T = g.top + (w.clientTop + parseFloat(_.paddingTop)) * x.y;
      c *= x.x, a *= x.y, p *= x.x, d *= x.y, c += S, a += T, m = Q(w), w = Dt(m);
    }
  }
  return gt({
    width: p,
    height: d,
    x: c,
    y: a
  });
}
function St(e, t) {
  const n = _t(e).scrollLeft;
  return t ? t.left + n : Le(me(e)).left + n;
}
function vo(e, t) {
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - St(e, n), l = n.top + t.scrollTop;
  return {
    x: o,
    y: l
  };
}
function an(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: l
  } = e;
  const r = l === "fixed", i = me(o), s = t ? xt(t.floating) : !1;
  if (o === i || s && r)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = de(1);
  const p = de(0), d = pe(o);
  if ((d || !d && !r) && ((Ke(o) !== "body" || st(i)) && (c = _t(o)), pe(o))) {
    const f = Le(o);
    a = Ve(o), p.x = f.x + o.clientLeft, p.y = f.y + o.clientTop;
  }
  const h = i && !d && !r ? vo(i, c) : de(0);
  return {
    width: n.width * a.x,
    height: n.height * a.y,
    x: n.x * a.x - c.scrollLeft * a.x + p.x + h.x,
    y: n.y * a.y - c.scrollTop * a.y + p.y + h.y
  };
}
function un(e) {
  return Array.from(e.getClientRects());
}
function fn(e) {
  const t = me(e), n = _t(e), o = e.ownerDocument.body, l = Ce(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), r = Ce(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let i = -n.scrollLeft + St(e);
  const s = -n.scrollTop;
  return se(o).direction === "rtl" && (i += Ce(t.clientWidth, o.clientWidth) - l), {
    width: l,
    height: r,
    x: i,
    y: s
  };
}
const Qt = 25;
function dn(e, t) {
  const n = Q(e), o = me(e), l = n.visualViewport;
  let r = o.clientWidth, i = o.clientHeight, s = 0, c = 0;
  if (l) {
    r = l.width, i = l.height;
    const p = Mt();
    (!p || p && t === "fixed") && (s = l.offsetLeft, c = l.offsetTop);
  }
  const a = St(o);
  if (a <= 0) {
    const p = o.ownerDocument, d = p.body, h = getComputedStyle(d), f = p.compatMode === "CSS1Compat" && parseFloat(h.marginLeft) + parseFloat(h.marginRight) || 0, m = Math.abs(o.clientWidth - d.clientWidth - f);
    m <= Qt && (r -= m);
  } else a <= Qt && (r += a);
  return {
    width: r,
    height: i,
    x: s,
    y: c
  };
}
const pn = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function mn(e, t) {
  const n = Le(e, !0, t === "fixed"), o = n.top + e.clientTop, l = n.left + e.clientLeft, r = pe(e) ? Ve(e) : de(1), i = e.clientWidth * r.x, s = e.clientHeight * r.y, c = l * r.x, a = o * r.y;
  return {
    width: i,
    height: s,
    x: c,
    y: a
  };
}
function Zt(e, t, n) {
  let o;
  if (t === "viewport")
    o = dn(e, n);
  else if (t === "document")
    o = fn(me(e));
  else if (ie(t))
    o = mn(t, n);
  else {
    const l = ho(e);
    o = {
      x: t.x - l.x,
      y: t.y - l.y,
      width: t.width,
      height: t.height
    };
  }
  return gt(o);
}
function yo(e, t) {
  const n = xe(e);
  return n === t || !ie(n) || qe(n) ? !1 : se(n).position === "fixed" || yo(n, t);
}
function hn(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = rt(e, [], !1).filter((s) => ie(s) && Ke(s) !== "body"), l = null;
  const r = se(e).position === "fixed";
  let i = r ? xe(e) : e;
  for (; ie(i) && !qe(i); ) {
    const s = se(i), c = It(i);
    !c && s.position === "fixed" && (l = null), (r ? !c && !l : !c && s.position === "static" && !!l && pn.has(l.position) || st(i) && !c && yo(e, i)) ? o = o.filter((p) => p !== i) : l = s, i = xe(i);
  }
  return t.set(e, o), o;
}
function vn(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: l
  } = e;
  const i = [...n === "clippingAncestors" ? xt(t) ? [] : hn(t, this._c) : [].concat(n), o], s = i[0], c = i.reduce((a, p) => {
    const d = Zt(t, p, l);
    return a.top = Ce(d.top, a.top), a.right = He(d.right, a.right), a.bottom = He(d.bottom, a.bottom), a.left = Ce(d.left, a.left), a;
  }, Zt(t, s, l));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function yn(e) {
  const {
    width: t,
    height: n
  } = mo(e);
  return {
    width: t,
    height: n
  };
}
function wn(e, t, n) {
  const o = pe(t), l = me(t), r = n === "fixed", i = Le(e, !0, r, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = de(0);
  function a() {
    c.x = St(l);
  }
  if (o || !o && !r)
    if ((Ke(t) !== "body" || st(l)) && (s = _t(t)), o) {
      const f = Le(t, !0, r, t);
      c.x = f.x + t.clientLeft, c.y = f.y + t.clientTop;
    } else l && a();
  r && !o && l && a();
  const p = l && !o && !r ? vo(l, s) : de(0), d = i.left + s.scrollLeft - c.x - p.x, h = i.top + s.scrollTop - c.y - p.y;
  return {
    x: d,
    y: h,
    width: i.width,
    height: i.height
  };
}
function Tt(e) {
  return se(e).position === "static";
}
function Gt(e, t) {
  if (!pe(e) || se(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return me(e) === n && (n = n.ownerDocument.body), n;
}
function wo(e, t) {
  const n = Q(e);
  if (xt(e))
    return n;
  if (!pe(e)) {
    let l = xe(e);
    for (; l && !qe(l); ) {
      if (ie(l) && !Tt(l))
        return l;
      l = xe(l);
    }
    return n;
  }
  let o = Gt(e, t);
  for (; o && Go(o) && Tt(o); )
    o = Gt(o, t);
  return o && qe(o) && Tt(o) && !It(o) ? n : o || rn(e) || n;
}
const gn = async function(e) {
  const t = this.getOffsetParent || wo, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: wn(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function bn(e) {
  return se(e).direction === "rtl";
}
const xn = {
  convertOffsetParentRelativeRectToViewportRelativeRect: an,
  getDocumentElement: me,
  getClippingRect: vn,
  getOffsetParent: wo,
  getElementRects: gn,
  getClientRects: un,
  getDimensions: yn,
  getScale: Ve,
  isElement: ie,
  isRTL: bn
};
function go(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function _n(e, t) {
  let n = null, o;
  const l = me(e);
  function r() {
    var s;
    clearTimeout(o), (s = n) == null || s.disconnect(), n = null;
  }
  function i(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), r();
    const a = e.getBoundingClientRect(), {
      left: p,
      top: d,
      width: h,
      height: f
    } = a;
    if (s || t(), !h || !f)
      return;
    const m = vt(d), w = vt(l.clientWidth - (p + h)), x = vt(l.clientHeight - (d + f)), g = vt(p), S = {
      rootMargin: -m + "px " + -w + "px " + -x + "px " + -g + "px",
      threshold: Ce(0, He(1, c)) || 1
    };
    let T = !0;
    function O(j) {
      const L = j[0].intersectionRatio;
      if (L !== c) {
        if (!T)
          return i();
        L ? i(!1, L) : o = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      L === 1 && !go(a, e.getBoundingClientRect()) && i(), T = !1;
    }
    try {
      n = new IntersectionObserver(O, {
        ...S,
        // Handle <iframe>s
        root: l.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(O, S);
    }
    n.observe(e);
  }
  return i(!0), r;
}
function Sn(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: l = !0,
    ancestorResize: r = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = o, a = jt(e), p = l || r ? [...a ? rt(a) : [], ...rt(t)] : [];
  p.forEach((g) => {
    l && g.addEventListener("scroll", n, {
      passive: !0
    }), r && g.addEventListener("resize", n);
  });
  const d = a && s ? _n(a, n) : null;
  let h = -1, f = null;
  i && (f = new ResizeObserver((g) => {
    let [_] = g;
    _ && _.target === a && f && (f.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var S;
      (S = f) == null || S.observe(t);
    })), n();
  }), a && !c && f.observe(a), f.observe(t));
  let m, w = c ? Le(e) : null;
  c && x();
  function x() {
    const g = Le(e);
    w && !go(w, g) && n(), w = g, m = requestAnimationFrame(x);
  }
  return n(), () => {
    var g;
    p.forEach((_) => {
      l && _.removeEventListener("scroll", n), r && _.removeEventListener("resize", n);
    }), d == null || d(), (g = f) == null || g.disconnect(), f = null, c && cancelAnimationFrame(m);
  };
}
const An = Uo, En = Jo, On = Ko, Rn = qo, eo = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), l = {
    platform: xn,
    ...n
  }, r = {
    ...l.platform,
    _c: o
  };
  return Ho(e, t, {
    ...l,
    platform: r
  });
};
var bo = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = "", i = 0; i < arguments.length; i++) {
        var s = arguments[i];
        s && (r = l(r, o(s)));
      }
      return r;
    }
    function o(r) {
      if (typeof r == "string" || typeof r == "number")
        return r;
      if (typeof r != "object")
        return "";
      if (Array.isArray(r))
        return n.apply(null, r);
      if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
        return r.toString();
      var i = "";
      for (var s in r)
        t.call(r, s) && r[s] && (i = l(i, s));
      return i;
    }
    function l(r, i) {
      return i ? r ? r + " " + i : r + i : r;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(bo);
var Cn = bo.exports;
const Pt = /* @__PURE__ */ Do(Cn);
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const Tn = "react-tooltip-core-styles", Ln = "react-tooltip-base-styles", to = { core: !1, base: !1 };
function oo({ css: e, id: t = Ln, type: n = "base", ref: o }) {
  var l, r;
  if (!e || typeof document > "u" || to[n] || n === "core" && typeof process < "u" && (!((l = process == null ? void 0 : process.env) === null || l === void 0) && l.REACT_TOOLTIP_DISABLE_CORE_STYLES) || n !== "base" && typeof process < "u" && (!((r = process == null ? void 0 : process.env) === null || r === void 0) && r.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
  n === "core" && (t = Tn), o || (o = {});
  const { insertAt: i } = o;
  if (document.getElementById(t)) return;
  const s = document.head || document.getElementsByTagName("head")[0], c = document.createElement("style");
  c.id = t, c.type = "text/css", i === "top" && s.firstChild ? s.insertBefore(c, s.firstChild) : s.appendChild(c), c.styleSheet ? c.styleSheet.cssText = e : c.appendChild(document.createTextNode(e)), to[n] = !0;
}
const no = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: n = null, place: o = "top", offset: l = 10, strategy: r = "absolute", middlewares: i = [An(Number(l)), On({ fallbackAxisSideDirection: "start" }), En({ padding: 5 })], border: s, arrowSize: c = 8 }) => {
  if (!e) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: o };
  if (t === null) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: o };
  const a = i;
  return n ? (a.push(Rn({ element: n, padding: 5 })), eo(e, t, { placement: o, strategy: r, middleware: a }).then(({ x: p, y: d, placement: h, middlewareData: f }) => {
    var m, w;
    const x = { left: `${p}px`, top: `${d}px`, border: s }, { x: g, y: _ } = (m = f.arrow) !== null && m !== void 0 ? m : { x: 0, y: 0 }, S = (w = { top: "bottom", right: "left", bottom: "top", left: "right" }[h.split("-")[0]]) !== null && w !== void 0 ? w : "bottom", T = s && { borderBottom: s, borderRight: s };
    let O = 0;
    if (s) {
      const j = `${s}`.match(/(\d+)px/);
      O = j != null && j[1] ? Number(j[1]) : 1;
    }
    return { tooltipStyles: x, tooltipArrowStyles: { left: g != null ? `${g}px` : "", top: _ != null ? `${_}px` : "", right: "", bottom: "", ...T, [S]: `-${c / 2 + O}px` }, place: h };
  })) : eo(e, t, { placement: "bottom", strategy: r, middleware: a }).then(({ x: p, y: d, placement: h }) => ({ tooltipStyles: { left: `${p}px`, top: `${d}px` }, tooltipArrowStyles: {}, place: h }));
}, ro = (e, t) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t), lo = (e, t, n) => {
  let o = null;
  const l = function(...r) {
    const i = () => {
      o = null;
    };
    !o && (e.apply(this, r), o = setTimeout(i, t));
  };
  return l.cancel = () => {
    o && (clearTimeout(o), o = null);
  }, l;
}, io = (e) => e !== null && !Array.isArray(e) && typeof e == "object", zt = (e, t) => {
  if (e === t) return !0;
  if (Array.isArray(e) && Array.isArray(t)) return e.length === t.length && e.every((l, r) => zt(l, t[r]));
  if (Array.isArray(e) !== Array.isArray(t)) return !1;
  if (!io(e) || !io(t)) return e === t;
  const n = Object.keys(e), o = Object.keys(t);
  return n.length === o.length && n.every((l) => zt(e[l], t[l]));
}, kn = (e) => {
  if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
  const t = getComputedStyle(e);
  return ["overflow", "overflow-x", "overflow-y"].some((n) => {
    const o = t.getPropertyValue(n);
    return o === "auto" || o === "scroll";
  });
}, so = (e) => {
  if (!e) return null;
  let t = e.parentElement;
  for (; t; ) {
    if (kn(t)) return t;
    t = t.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, Nn = typeof window < "u" ? Co : C, oe = (e) => {
  e.current && (clearTimeout(e.current), e.current = null);
}, Dn = "DEFAULT_TOOLTIP_ID", Pn = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, zn = Oo({ getTooltipData: () => Pn });
function xo(e = Dn) {
  return Ro(zn).getTooltipData(e);
}
var We = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, Lt = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const $n = ({ forwardRef: e, id: t, className: n, classNameArrow: o, variant: l = "dark", anchorId: r, anchorSelect: i, place: s = "top", offset: c = 10, events: a = ["hover"], openOnClick: p = !1, positionStrategy: d = "absolute", middlewares: h, wrapper: f, delayShow: m = 0, delayHide: w = 0, float: x = !1, hidden: g = !1, noArrow: _ = !1, clickable: S = !1, closeOnEsc: T = !1, closeOnScroll: O = !1, closeOnResize: j = !1, openEvents: L, closeEvents: Z, globalCloseEvents: X, imperativeModeOnly: Y, style: ce, position: G, afterShow: ae, afterHide: R, disableTooltip: K, content: W, contentWrapperRef: $, isOpen: N, defaultIsOpen: V = !1, setIsOpen: he, activeAnchor: B, setActiveAnchor: ke, border: ct, opacity: at, arrowColor: ut, arrowSize: Ne = 8, role: At = "tooltip" }) => {
  var Xe;
  const H = le(null), De = le(null), ne = le(null), ye = le(null), Ye = le(null), [we, Et] = z({ tooltipStyles: {}, tooltipArrowStyles: {}, place: s }), [U, ft] = z(!1), [_e, Se] = z(!1), [D, Ue] = z(null), Je = le(!1), Qe = le(null), { anchorRefs: Ze, setActiveAnchor: dt } = xo(t), Pe = le(!1), [ge, Ge] = z([]), Ae = le(!1), ze = p || a.includes("click"), Ot = ze || (L == null ? void 0 : L.click) || (L == null ? void 0 : L.dblclick) || (L == null ? void 0 : L.mousedown), $e = L ? { ...L } : { mouseover: !0, focus: !0, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 };
  !L && ze && Object.assign($e, { mouseenter: !1, focus: !1, mouseover: !1, click: !0 });
  const Ee = Z ? { ...Z } : { mouseout: !0, blur: !0, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 };
  !Z && ze && Object.assign(Ee, { mouseleave: !1, blur: !1, mouseout: !1 });
  const re = X ? { ...X } : { escape: T || !1, scroll: O || !1, resize: j || !1, clickOutsideAnchor: Ot || !1 };
  Y && (Object.assign($e, { mouseover: !1, focus: !1, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(Ee, { mouseout: !1, blur: !1, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(re, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), Nn(() => (Ae.current = !0, () => {
    Ae.current = !1;
  }), []);
  const P = (u) => {
    Ae.current && (u && Se(!0), setTimeout(() => {
      Ae.current && (he == null || he(u), N === void 0 && ft(u));
    }, 10));
  };
  C(() => {
    if (N === void 0) return () => null;
    N && Se(!0);
    const u = setTimeout(() => {
      ft(N);
    }, 10);
    return () => {
      clearTimeout(u);
    };
  }, [N]), C(() => {
    if (U !== Je.current) if (oe(Ye), Je.current = U, U) ae == null || ae();
    else {
      const u = ((y) => {
        const b = y.match(/^([\d.]+)(ms|s)$/);
        if (!b) return 0;
        const [, I, F] = b;
        return Number(I) * (F === "ms" ? 1 : 1e3);
      })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
      Ye.current = setTimeout(() => {
        Se(!1), Ue(null), R == null || R();
      }, u + 25);
    }
  }, [U]);
  const pt = (u) => {
    Et((y) => zt(y, u) ? y : u);
  }, et = (u = m) => {
    oe(ne), _e ? P(!0) : ne.current = setTimeout(() => {
      P(!0);
    }, u);
  }, Be = (u = w) => {
    oe(ye), ye.current = setTimeout(() => {
      Pe.current || P(!1);
    }, u);
  }, tt = (u) => {
    var y;
    if (!u) return;
    const b = (y = u.currentTarget) !== null && y !== void 0 ? y : u.target;
    if (!(b != null && b.isConnected)) return ke(null), void dt({ current: null });
    m ? et() : P(!0), ke(b), dt({ current: b }), oe(ye);
  }, Ie = () => {
    S ? Be(w || 100) : w ? Be() : P(!1), oe(ne);
  }, Me = ({ x: u, y }) => {
    var b;
    const I = { getBoundingClientRect: () => ({ x: u, y, width: 0, height: 0, top: y, left: u, right: u, bottom: y }) };
    no({ place: (b = D == null ? void 0 : D.place) !== null && b !== void 0 ? b : s, offset: c, elementReference: I, tooltipReference: H.current, tooltipArrowReference: De.current, strategy: d, middlewares: h, border: ct, arrowSize: Ne }).then((F) => {
      pt(F);
    });
  }, je = (u) => {
    if (!u) return;
    const y = u, b = { x: y.clientX, y: y.clientY };
    Me(b), Qe.current = b;
  }, ot = (u) => {
    var y;
    if (!U) return;
    const b = u.target;
    b.isConnected && (!((y = H.current) === null || y === void 0) && y.contains(b) || [document.querySelector(`[id='${r}']`), ...ge].some((I) => I == null ? void 0 : I.contains(b)) || (P(!1), oe(ne)));
  }, mt = lo(tt, 50), M = lo(Ie, 50), ee = (u) => {
    M.cancel(), mt(u);
  }, v = () => {
    mt.cancel(), M();
  }, A = To(() => {
    var u, y;
    const b = (u = D == null ? void 0 : D.position) !== null && u !== void 0 ? u : G;
    b ? Me(b) : x ? Qe.current && Me(Qe.current) : B != null && B.isConnected && no({ place: (y = D == null ? void 0 : D.place) !== null && y !== void 0 ? y : s, offset: c, elementReference: B, tooltipReference: H.current, tooltipArrowReference: De.current, strategy: d, middlewares: h, border: ct, arrowSize: Ne }).then((I) => {
      Ae.current && pt(I);
    });
  }, [U, B, W, ce, s, D == null ? void 0 : D.place, c, d, G, D == null ? void 0 : D.position, x, Ne]);
  C(() => {
    var u, y;
    const b = new Set(Ze);
    ge.forEach((E) => {
      K != null && K(E) || b.add({ current: E });
    });
    const I = document.querySelector(`[id='${r}']`);
    I && !(K != null && K(I)) && b.add({ current: I });
    const F = () => {
      P(!1);
    }, ue = so(B), fe = so(H.current);
    re.scroll && (window.addEventListener("scroll", F), ue == null || ue.addEventListener("scroll", F), fe == null || fe.addEventListener("scroll", F));
    let q = null;
    re.resize ? window.addEventListener("resize", F) : B && H.current && (q = Sn(B, H.current, A, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const te = (E) => {
      E.key === "Escape" && P(!1);
    };
    re.escape && window.addEventListener("keydown", te), re.clickOutsideAnchor && window.addEventListener("click", ot);
    const k = [], Fe = (E) => !!(E != null && E.target && (B != null && B.contains(E.target))), _o = (E) => {
      U && Fe(E) || tt(E);
    }, So = (E) => {
      U && Fe(E) && Ie();
    }, Ft = ["mouseover", "mouseout", "mouseenter", "mouseleave", "focus", "blur"], Wt = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries($e).forEach(([E, ve]) => {
      ve && (Ft.includes(E) ? k.push({ event: E, listener: ee }) : Wt.includes(E) && k.push({ event: E, listener: _o }));
    }), Object.entries(Ee).forEach(([E, ve]) => {
      ve && (Ft.includes(E) ? k.push({ event: E, listener: v }) : Wt.includes(E) && k.push({ event: E, listener: So }));
    }), x && k.push({ event: "pointermove", listener: je });
    const Vt = () => {
      Pe.current = !0;
    }, Ht = () => {
      Pe.current = !1, Ie();
    }, qt = S && (Ee.mouseout || Ee.mouseleave);
    return qt && ((u = H.current) === null || u === void 0 || u.addEventListener("mouseover", Vt), (y = H.current) === null || y === void 0 || y.addEventListener("mouseout", Ht)), k.forEach(({ event: E, listener: ve }) => {
      b.forEach((Rt) => {
        var nt;
        (nt = Rt.current) === null || nt === void 0 || nt.addEventListener(E, ve);
      });
    }), () => {
      var E, ve;
      re.scroll && (window.removeEventListener("scroll", F), ue == null || ue.removeEventListener("scroll", F), fe == null || fe.removeEventListener("scroll", F)), re.resize ? window.removeEventListener("resize", F) : q == null || q(), re.clickOutsideAnchor && window.removeEventListener("click", ot), re.escape && window.removeEventListener("keydown", te), qt && ((E = H.current) === null || E === void 0 || E.removeEventListener("mouseover", Vt), (ve = H.current) === null || ve === void 0 || ve.removeEventListener("mouseout", Ht)), k.forEach(({ event: Rt, listener: nt }) => {
        b.forEach((Ao) => {
          var Ct;
          (Ct = Ao.current) === null || Ct === void 0 || Ct.removeEventListener(Rt, nt);
        });
      });
    };
  }, [B, A, _e, Ze, ge, L, Z, X, ze, m, w]), C(() => {
    var u, y;
    let b = (y = (u = D == null ? void 0 : D.anchorSelect) !== null && u !== void 0 ? u : i) !== null && y !== void 0 ? y : "";
    !b && t && (b = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`);
    const I = new MutationObserver((F) => {
      const ue = [], fe = [];
      F.forEach((q) => {
        if (q.type === "attributes" && q.attributeName === "data-tooltip-id" && (q.target.getAttribute("data-tooltip-id") === t ? ue.push(q.target) : q.oldValue === t && fe.push(q.target)), q.type === "childList") {
          if (B) {
            const te = [...q.removedNodes].filter((k) => k.nodeType === 1);
            if (b) try {
              fe.push(...te.filter((k) => k.matches(b))), fe.push(...te.flatMap((k) => [...k.querySelectorAll(b)]));
            } catch {
            }
            te.some((k) => {
              var Fe;
              return !!(!((Fe = k == null ? void 0 : k.contains) === null || Fe === void 0) && Fe.call(k, B)) && (Se(!1), P(!1), ke(null), oe(ne), oe(ye), !0);
            });
          }
          if (b) try {
            const te = [...q.addedNodes].filter((k) => k.nodeType === 1);
            ue.push(...te.filter((k) => k.matches(b))), ue.push(...te.flatMap((k) => [...k.querySelectorAll(b)]));
          } catch {
          }
        }
      }), (ue.length || fe.length) && Ge((q) => [...q.filter((te) => !fe.includes(te)), ...ue]);
    });
    return I.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"], attributeOldValue: !0 }), () => {
      I.disconnect();
    };
  }, [t, i, D == null ? void 0 : D.anchorSelect, B]), C(() => {
    A();
  }, [A]), C(() => {
    if (!($ != null && $.current)) return () => null;
    const u = new ResizeObserver(() => {
      setTimeout(() => A());
    });
    return u.observe($.current), () => {
      u.disconnect();
    };
  }, [W, $ == null ? void 0 : $.current]), C(() => {
    var u;
    const y = document.querySelector(`[id='${r}']`), b = [...ge, y];
    B && b.includes(B) || ke((u = ge[0]) !== null && u !== void 0 ? u : y);
  }, [r, ge, B]), C(() => (V && P(!0), () => {
    oe(ne), oe(ye);
  }), []), C(() => {
    var u;
    let y = (u = D == null ? void 0 : D.anchorSelect) !== null && u !== void 0 ? u : i;
    if (!y && t && (y = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), y) try {
      const b = Array.from(document.querySelectorAll(y));
      Ge(b);
    } catch {
      Ge([]);
    }
  }, [t, i, D == null ? void 0 : D.anchorSelect]), C(() => {
    ne.current && (oe(ne), et(m));
  }, [m]);
  const J = (Xe = D == null ? void 0 : D.content) !== null && Xe !== void 0 ? Xe : W, Oe = U && Object.keys(we.tooltipStyles).length > 0;
  return Lo(e, () => ({ open: (u) => {
    if (u != null && u.anchorSelect) try {
      document.querySelector(u.anchorSelect);
    } catch {
      return void console.warn(`[react-tooltip] "${u.anchorSelect}" is not a valid CSS selector`);
    }
    Ue(u ?? null), u != null && u.delay ? et(u.delay) : P(!0);
  }, close: (u) => {
    u != null && u.delay ? Be(u.delay) : P(!1);
  }, activeAnchor: B, place: we.place, isOpen: !!(_e && !g && J && Oe) })), _e && !g && J ? Re.createElement(f, { id: t, role: At, className: Pt("react-tooltip", We.tooltip, Lt.tooltip, Lt[l], n, `react-tooltip__place-${we.place}`, We[Oe ? "show" : "closing"], Oe ? "react-tooltip__show" : "react-tooltip__closing", d === "fixed" && We.fixed, S && We.clickable), onTransitionEnd: (u) => {
    oe(Ye), U || u.propertyName !== "opacity" || (Se(!1), Ue(null), R == null || R());
  }, style: { ...ce, ...we.tooltipStyles, opacity: at !== void 0 && Oe ? at : void 0 }, ref: H }, J, Re.createElement(f, { className: Pt("react-tooltip-arrow", We.arrow, Lt.arrow, o, _ && We.noArrow), style: { ...we.tooltipArrowStyles, background: ut ? `linear-gradient(to right bottom, transparent 50%, ${ut} 50%)` : void 0, "--rt-arrow-size": `${Ne}px` }, ref: De })) : null;
}, Bn = ({ content: e }) => Re.createElement("span", { dangerouslySetInnerHTML: { __html: e } }), In = Re.forwardRef(({ id: e, anchorId: t, anchorSelect: n, content: o, html: l, render: r, className: i, classNameArrow: s, variant: c = "dark", place: a = "top", offset: p = 10, wrapper: d = "div", children: h = null, events: f = ["hover"], openOnClick: m = !1, positionStrategy: w = "absolute", middlewares: x, delayShow: g = 0, delayHide: _ = 0, float: S = !1, hidden: T = !1, noArrow: O = !1, clickable: j = !1, closeOnEsc: L = !1, closeOnScroll: Z = !1, closeOnResize: X = !1, openEvents: Y, closeEvents: ce, globalCloseEvents: G, imperativeModeOnly: ae = !1, style: R, position: K, isOpen: W, defaultIsOpen: $ = !1, disableStyleInjection: N = !1, border: V, opacity: he, arrowColor: B, arrowSize: ke, setIsOpen: ct, afterShow: at, afterHide: ut, disableTooltip: Ne, role: At = "tooltip" }, Xe) => {
  const [H, De] = z(o), [ne, ye] = z(l), [Ye, we] = z(a), [Et, U] = z(c), [ft, _e] = z(p), [Se, D] = z(g), [Ue, Je] = z(_), [Qe, Ze] = z(S), [dt, Pe] = z(T), [ge, Ge] = z(d), [Ae, ze] = z(f), [Ot, $e] = z(w), [Ee, re] = z(null), [P, pt] = z(null), et = le(N), { anchorRefs: Be, activeAnchor: tt } = xo(e), Ie = (M) => M == null ? void 0 : M.getAttributeNames().reduce((ee, v) => {
    var A;
    return v.startsWith("data-tooltip-") && (ee[v.replace(/^data-tooltip-/, "")] = (A = M == null ? void 0 : M.getAttribute(v)) !== null && A !== void 0 ? A : null), ee;
  }, {}), Me = (M) => {
    const ee = { place: (v) => {
      var A;
      we((A = v) !== null && A !== void 0 ? A : a);
    }, content: (v) => {
      De(v ?? o);
    }, html: (v) => {
      ye(v ?? l);
    }, variant: (v) => {
      var A;
      U((A = v) !== null && A !== void 0 ? A : c);
    }, offset: (v) => {
      _e(v === null ? p : Number(v));
    }, wrapper: (v) => {
      var A;
      Ge((A = v) !== null && A !== void 0 ? A : d);
    }, events: (v) => {
      const A = v == null ? void 0 : v.split(" ");
      ze(A ?? f);
    }, "position-strategy": (v) => {
      var A;
      $e((A = v) !== null && A !== void 0 ? A : w);
    }, "delay-show": (v) => {
      D(v === null ? g : Number(v));
    }, "delay-hide": (v) => {
      Je(v === null ? _ : Number(v));
    }, float: (v) => {
      Ze(v === null ? S : v === "true");
    }, hidden: (v) => {
      Pe(v === null ? T : v === "true");
    }, "class-name": (v) => {
      re(v);
    } };
    Object.values(ee).forEach((v) => v(null)), Object.entries(M).forEach(([v, A]) => {
      var J;
      (J = ee[v]) === null || J === void 0 || J.call(ee, A);
    });
  };
  C(() => {
    De(o);
  }, [o]), C(() => {
    ye(l);
  }, [l]), C(() => {
    we(a);
  }, [a]), C(() => {
    U(c);
  }, [c]), C(() => {
    _e(p);
  }, [p]), C(() => {
    D(g);
  }, [g]), C(() => {
    Je(_);
  }, [_]), C(() => {
    Ze(S);
  }, [S]), C(() => {
    Pe(T);
  }, [T]), C(() => {
    $e(w);
  }, [w]), C(() => {
    et.current !== N && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [N]), C(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: N === "core", disableBase: N } }));
  }, []), C(() => {
    var M;
    const ee = new Set(Be);
    let v = n;
    if (!v && e && (v = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`), v) try {
      document.querySelectorAll(v).forEach((y) => {
        ee.add({ current: y });
      });
    } catch {
      console.warn(`[react-tooltip] "${v}" is not a valid CSS selector`);
    }
    const A = document.querySelector(`[id='${t}']`);
    if (A && ee.add({ current: A }), !ee.size) return () => null;
    const J = (M = P ?? A) !== null && M !== void 0 ? M : tt.current, Oe = new MutationObserver((y) => {
      y.forEach((b) => {
        var I;
        if (!J || b.type !== "attributes" || !(!((I = b.attributeName) === null || I === void 0) && I.startsWith("data-tooltip-"))) return;
        const F = Ie(J);
        Me(F);
      });
    }), u = { attributes: !0, childList: !1, subtree: !1 };
    if (J) {
      const y = Ie(J);
      Me(y), Oe.observe(J, u);
    }
    return () => {
      Oe.disconnect();
    };
  }, [Be, tt, P, t, n]), C(() => {
    R != null && R.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), V && !ro("border", `${V}`) && console.warn(`[react-tooltip] "${V}" is not a valid \`border\`.`), R != null && R.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), he && !ro("opacity", `${he}`) && console.warn(`[react-tooltip] "${he}" is not a valid \`opacity\`.`);
  }, []);
  let je = h;
  const ot = le(null);
  if (r) {
    const M = r({ content: (P == null ? void 0 : P.getAttribute("data-tooltip-content")) || H || null, activeAnchor: P });
    je = M ? Re.createElement("div", { ref: ot, className: "react-tooltip-content-wrapper" }, M) : null;
  } else H && (je = H);
  ne && (je = Re.createElement(Bn, { content: ne }));
  const mt = { forwardRef: Xe, id: e, anchorId: t, anchorSelect: n, className: Pt(i, Ee), classNameArrow: s, content: je, contentWrapperRef: ot, place: Ye, variant: Et, offset: ft, wrapper: ge, events: Ae, openOnClick: m, positionStrategy: Ot, middlewares: x, delayShow: Se, delayHide: Ue, float: Qe, hidden: dt, noArrow: O, clickable: j, closeOnEsc: L, closeOnScroll: Z, closeOnResize: X, openEvents: Y, closeEvents: ce, globalCloseEvents: G, imperativeModeOnly: ae, style: R, position: K, isOpen: W, defaultIsOpen: $, border: V, opacity: he, arrowColor: B, arrowSize: ke, setIsOpen: ct, afterShow: at, afterHide: ut, disableTooltip: Ne, activeAnchor: P, setActiveAnchor: (M) => pt(M), role: At };
  return Re.createElement($n, { ...mt });
});
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (e) => {
  e.detail.disableCore || oo({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s;--rt-arrow-size:8px}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit;z-index:-1}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), e.detail.disableBase || oo({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:var(--rt-arrow-size);height:var(--rt-arrow-size)}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
const Mn = (e) => {
  const { children: t, eventType: n = "click", showCloseButton: o = !1, className: l, ...r } = e, [i, s] = z(r.isOpen);
  return C(() => {
    s(r.isOpen);
  }, [r.isOpen]), /* @__PURE__ */ ht(
    In,
    {
      ...r,
      className: Kt(
        "!pointer-events-auto min-w-100 max-w-[280px] !rounded-6 !bg-fill-neutral-main !p-4 !typography-body-12-regular-multiline",
        l
      ),
      classNameArrow: Kt("!size-[8.5px]", e.classNameArrow),
      events: [n],
      globalCloseEvents: {
        clickOutsideAnchor: !o
      },
      isOpen: i,
      opacity: 1,
      setIsOpen: s,
      children: /* @__PURE__ */ Eo("div", { className: "flex", children: [
        /* @__PURE__ */ ht("div", { className: "p-8", children: t }),
        !!o && /* @__PURE__ */ ht(
          No,
          {
            className: "size-32",
            icon: /* @__PURE__ */ ht(ko, {}),
            onClick: () => {
              s(!1);
            },
            size: "small",
            theme: "transparent"
          }
        )
      ] })
    }
  );
};
Mn.displayName = "NDS.Tooltip";
export {
  Mn as T
};
